import { render } from "./WeDeclareWarVideo.vue?vue&type=template&id=64b454b2&scoped=true"
import script from "./WeDeclareWarVideo.vue?vue&type=script&lang=js"
export * from "./WeDeclareWarVideo.vue?vue&type=script&lang=js"

import "./WeDeclareWarVideo.vue?vue&type=style&index=0&id=64b454b2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b454b2"]])

export default __exports__